import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-bottom-bar',
  templateUrl: './bottom-bar.component.html',
  styleUrls: ['./bottom-bar.component.scss']
})
export class BottomBarComponent implements OnInit {
  @Input() next: string;
  @Input() previous: string;
  @Input() nextEnabled: boolean;
  @Input() errorMsg: string;
  @Output() error: EventEmitter<string> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  showError() {
    this.error.emit(this.errorMsg);
  }

}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/company-setup/bottom-bar/bottom-bar.component.ts